import { render, staticRenderFns } from "./TeamLayout.vue?vue&type=template&id=49a00287&scoped=true&"
import script from "./TeamLayout.vue?vue&type=script&lang=js&"
export * from "./TeamLayout.vue?vue&type=script&lang=js&"
import style0 from "./TeamLayout.vue?vue&type=style&index=0&id=49a00287&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a00287",
  null
  
)

export default component.exports